module.exports = __webpack_public_path__ + "img/icon_invite-fb.b74f506f.svg";